import React from 'react';
import Input from 'components/form/TextInput';
import Form from 'components/form';
import { useForm } from './Form';
const { FormItem } = Form;

const TextField = ({ id, required, inputProps, ...props }) => {
  const { getFieldDecorator } = useForm();

  const maxLength = props.multiline ? 1000 : 100;

  return (
    <FormItem>
      {getFieldDecorator(id, {
        rules: [
          { required, message: 'Required' },
          { max: maxLength, message: `Max ${maxLength} characters` },
        ],
      })(
        <Input
          {...props}
          fullWidth
          inputProps={inputProps}
          margin="dense"
          helpText="This field is required"
          placeholder="Type your answer here..."
        />,
      )}
    </FormItem>
  );
};

export default TextField;
